import { Error } from '../../../api/setup/getApiError';

export type SecretState = {
  getDataFetching: boolean;
  saveDataFetching: boolean;
  newKeyFetching: boolean;
  selectedSignature: SignatureTypes;
  initialSignature: SignatureTypes;
  currHMAC: string;
  newHMAC: string;
  currRSA: RSA | null;
  newRSA: RSA | null;
  getDataError: Error | null;
  getNewKeyError: string;
  tokenLifetime: number | undefined;
  initialTokenLifetime: number | undefined;
  tokenLifetimeError: string;
  agreeLongToken: boolean;
};

export type RSA = {
  alg: string;
  e: string;
  kid: string;
  kty: string;
  n: string;
  use: string;
  x5c?: string;
  x5t?: string;
};

export type GetDataResponse = [string, Array<RSA>];

export type GetDataPayload = {
  hmac: string;
  rsa: RSA | null;
  selectedSignature: SignatureTypes;
};

export type FormValues = {
  token_expiration_time: number;
};

export enum SignatureTypes {
  hmac = 'hmac',
  rsa = 'rsa'
}

export enum ActionType {
  getDataSuccess = 'getDataSuccess',
  getDataFail = 'getDataFail',
  getNewHMAC = 'getNewHMAC',
  getNewRSAStart = 'getNewRSAStart',
  getNewRSASuccess = 'getNewRSASuccess',
  getNewRSAFail = 'getNewRSAFail',
  changeSelectedSignature = 'changeSelectedSignature',
  changeTokenLifetime = 'changeTokenLifetime',
  changeTokenLifetimeError = 'changeTokenLifetimeError',
  submitStart = 'submitStart',
  submitSuccess = 'submitSuccess',
  submitFail = 'submitFail',
  submitAgreeLongToken = 'submitAgreeLongToken'
}

export type Action =
  | {
      type: ActionType.getDataSuccess;
      payload: GetDataPayload;
    }
  | { type: ActionType.getDataFail; payload: Error }
  | { type: ActionType.getNewHMAC; payload: string }
  | { type: ActionType.getNewRSAStart }
  | { type: ActionType.getNewRSASuccess; payload: RSA }
  | { type: ActionType.getNewRSAFail; payload: string }
  | { type: ActionType.changeSelectedSignature }
  | { type: ActionType.changeTokenLifetime; payload: number | undefined }
  | { type: ActionType.changeTokenLifetimeError; payload: string }
  | { type: ActionType.submitStart }
  | { type: ActionType.submitSuccess }
  | { type: ActionType.submitFail }
  | { type: ActionType.submitAgreeLongToken; payload: boolean };
